<template>
  <div>
    <el-card class="goods-card" @click.native="goPage" :body-style="{ padding: '5px' }">
      <img :src="goodsItem.goods_images[0]" width="100%" :height="goodsheight" class="image">
      <div class="flex flex-t">
        <div class="price">￥{{goodsItem.goods_price}}</div>
        <div>{{goodsItem.goods_weight}}g/件</div>
      </div>
      <div class="flex flex-b">
        <div class="gname">{{goodsItem.goods_name}}</div>
        <div>{{goodsItem.goods_storage}}</div>
      </div>
    </el-card>
  </div>
</template>

<script>
// import goodsDialog from '@/components/goodsDialog.vue'
export default {
  components: {
    // goodsDialog
  },
  props: {
    goodsItem: Object
  },
  data () {
    return {
      //计算选择礼品时礼品列表图片宽度
      goodsheight: Math.round((window.innerWidth - 15) * 0.46 * 0.96)+'px',
      dialogVisible: false
    }
  },
  methods: {
    goPage() {
	window.location.href='/m/orderAdmin/purchase'
    },
    diaShow (item, goodsItem) {
      // console.log(3333, item)
      this.$refs.sons.dialogShow(item, goodsItem)
    }
    // 点击每个商品跳转
    // toMall (goodsItem) {
    //   console.log(goodsItem)
    //   // this.$router.push('/goods')
    // }
  }
}
</script>

<style scoped src="styles/views/index/hotgoodscard.css">
</style>
